const webData = {
  solutionData: {
    name: '解决方案',
    list: [
      {
        title: '省卫健委合作项目',
        path: '/solution?id=1',
      },
      {
        title: '智慧医院',
        path: '/solution?id=2',
      },
      {
        title: '全民健康信息平台',
        path: '/solution?id=3',
      },
    ],
  },
  productData: {
    name: '产品与服务',
    list: [
      {
        title: '健康医疗数据中心',
        path: '/product?id=1',
      },
      {
        title: '智慧服务',
        path: '/product?id=2',
      },
      {
        title: '智慧临床',
        path: '/product?id=3',
      },
      {
        title: '智慧管理',
        path: '/product?id=4',
      },
    ],
  },
  aboutData: {
    name: '关于扁鹊',
    list: [
      {
        title: '公司简介',
        path: '/about?id=0',
      },
      {
        title: '扁鹊孵化器',
        path: '/about?id=1',
      },
      {
        title: '新闻动态',
        path: '/about?id=2',
      },
      // {
      //   title: '公司文化',
      //   path: '/about?locat=concat',
      // },
    ],
  },
  contactData: {
    name: '联系我们',
    list: [
      {
        title: '合作咨询',
        path: '/contact?id=0',
      },
      {
        title: '加入我们',
        path: '/contact?id=1',
      },
    ],
  },
};

export const website_v3 = [
  // {
  //   title: aboutData.title,
  //   list: webData.aboutData.list,
  //   flex: true,
  // },
  // {
  //   title: webData.addressData.name,
  //   list: webData.addressData.list,
  // },
  {
    title: webData.solutionData.name,
    list: webData.solutionData.list,
  },
  {
    title: webData.productData.name,
    list: webData.productData.list,
  },
  {
    title: webData.aboutData.name,
    list: webData.aboutData.list,
  },
  {
    title: webData.contactData.name,
    list: webData.contactData.list,
  },
];
